import { Variant } from "@/types/types";
import { EnergyLabelsResponse } from "../../../data/EnergyLabelsFetcher";
import EnergyCostGraph from "../EnergyCostGraph/EnergyCostGraph";
import styles from "./EfficiencyPanel.module.scss";
import { HorizontalRule } from "@/components";
import { getEnergyLabelResult } from "../../../utils";
import { useEffect, useState } from "react";
import { EnergyLabelProductFoundResult } from "@/components/EnergySaving/data/energyLabelResponseSchema.ts";

type Props = {
  variant: Variant;
  updateResponse: EnergyLabelsResponse;
};

function replaceNbsps(str: string) {
  const re = new RegExp(/&nbsp;/i, "g");
  return str.replace(re, " ");
}

const EfficiencyPanel = ({ variant, updateResponse }: Props) => {
  const [saving, setSaving] = useState("");
  const [model, setModel] = useState("");
  const [leastEfficientCost, setLeastEfficientCost] = useState("");
  const [thisModelCost, setThisModelCost] = useState("");

  const updateEnergyValues = (
    response: EnergyLabelsResponse,
    variant: Variant,
  ) => {
    const result = getEnergyLabelResult(response, variant);

    if (result) {
      const {
        energyCostSaving,
        energyCost,
        ekoGroupValueRatingTextPlural,
        leastEfficientEnergyCost,
      } = result as EnergyLabelProductFoundResult;

      setSaving(replaceNbsps(energyCostSaving));
      setModel(replaceNbsps(ekoGroupValueRatingTextPlural));
      setLeastEfficientCost(replaceNbsps(leastEfficientEnergyCost));
      setThisModelCost(replaceNbsps(energyCost));
    }
  };

  useEffect(() => {
    if (updateResponse) {
      updateEnergyValues(updateResponse, variant);
    }
  }, [updateResponse]);

  const latestResult = getEnergyLabelResult(updateResponse, variant);

  if (!latestResult) return null;

  return (
    <div className={styles.efficiency}>
      <h1 className={styles.efficiency__saving}>{saving}</h1>
      <h2 className={styles.efficiency__heading}>lifetime energy savings</h2>
      <p>
        We&apos;ve calculated the lifetime energy cost of running the least
        efficient {model} model ({leastEfficientCost}), and subtracted the
        lifetime energy cost of running this model ({thisModelCost}). This
        results in a {saving} lifetime energy saving.
      </p>
      <HorizontalRule />
      <h2 className={styles.efficiency__heading}>Lifetime energy costs</h2>
      <EnergyCostGraph energyResult={latestResult} />
    </div>
  );
};

export default EfficiencyPanel;
